import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';

export const Schema = (settings) => Yup.object().shape({
    phoneNumber: Yup.string()
        .matches(RegExp(settings.applicationPhoneNumberRegex), "Ungültige Telefonnummer")
        .required("Angabe ist erforderlich"),
});

export const ContactSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formPhoneNumber">
                <Form.Label>Telefon*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Telefon eingeben"
                    type="text"
                    name="phoneNumber"
                    value={values.phoneNumber}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.phoneNumber && !errors.phoneNumber}
                    isInvalid={touched.phoneNumber && errors.phoneNumber}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.phoneNumber}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};